import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue";
var _hoisted_1 = {
  "class": /*@__PURE__*/_normalizeClass(['tui-date-table']),
  cellspacing: "0",
  cellpadding: "0",
  role: "grid"
};
var _hoisted_2 = {
  "class": /*@__PURE__*/_normalizeClass(['tui-date-table-body'])
};
var _hoisted_3 = {
  "class": /*@__PURE__*/_normalizeClass(['tui-date-table-body-weeks'])
};
var _hoisted_4 = ["aria-label"];
var _hoisted_5 = ["onClick"];
var _hoisted_6 = {
  "class": /*@__PURE__*/_normalizeClass('tui-date-table-body-days-item-cell-text')
};
import { computed, ref } from "../../../adapter-vue";
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import dayjs, { Dayjs } from "dayjs";
import "dayjs/locale/zh-cn";
export default /*@__PURE__*/_defineComponent({
  __name: 'date-table',
  props: {
    type: {
      type: String,
      "default": "range" // "single"/"range"
    },
    currentPanelDate: {
      type: Dayjs,
      "default": function _default() {
        return dayjs();
      }
    },
    // type 为 single 时特有属性
    date: {
      type: Dayjs,
      "default": null
    },
    // type 为 range时特有属性
    startDate: {
      type: Dayjs,
      "default": null
    },
    endDate: {
      type: Dayjs,
      "default": null
    }
  },
  emits: ["pick"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emit = __emit;
    // 当前日期
    var now = dayjs();
    // 面板行数
    var tableRows = ref([[], [], [], [], [], []]);
    var WEEKS_CONSTANT = computed(function () {
      return dayjs.weekdaysShort();
    });
    // 表头数据
    var WEEKS = computed(function () {
      return WEEKS_CONSTANT.value.map(function (w) {
        return w.substring(1);
      });
    });
    // 表格开始日期
    var startDate = computed(function () {
      var _props$currentPanelDa;
      var startDayOfMonth = props === null || props === void 0 || (_props$currentPanelDa = props.currentPanelDate) === null || _props$currentPanelDa === void 0 ? void 0 : _props$currentPanelDa.startOf("month");
      return startDayOfMonth.subtract(startDayOfMonth.day() || 7, "day");
    });
    // 表格数据
    var rows = computed(function () {
      var rows_ = tableRows.value;
      var cols = WEEKS.value.length;
      // 当月第一天
      var startOfMonth = props.currentPanelDate.startOf("month");
      var startOfMonthDay = startOfMonth.day() || 7; // day of this month first day
      var dateCountOfMonth = startOfMonth.daysInMonth(); // total days of this month
      var count = 1;
      // 循环填充表格，6行7列
      for (var row = 0; row < tableRows.value.length; row++) {
        for (var col = 0; col < cols; col++) {
          var _props$date, _props$startDate, _props$endDate;
          var cellDate = startDate.value.add(count, "day");
          var text = cellDate.date();
          // 对于 type === "single", 选中传入日期
          // 对于 type === "range", 选中传入的开始与结束的日期
          var isSelected = props.type === "single" && cellDate.format("YYYY-MM-DD") === (props === null || props === void 0 || (_props$date = props.date) === null || _props$date === void 0 ? void 0 : _props$date.format("YYYY-MM-DD"));
          var isSelectedStart = props.type === "range" && cellDate.format("YYYY-MM-DD") === (props === null || props === void 0 || (_props$startDate = props.startDate) === null || _props$startDate === void 0 ? void 0 : _props$startDate.format("YYYY-MM-DD"));
          var isSelectedEnd = props.type === "range" && cellDate.format("YYYY-MM-DD") === (props === null || props === void 0 || (_props$endDate = props.endDate) === null || _props$endDate === void 0 ? void 0 : _props$endDate.format("YYYY-MM-DD"));
          // 对于 type === "range", 是否在选择区间中
          var isInRange = cellDate.isSameOrBefore(props.endDate, "day") && cellDate.isSameOrAfter(props.startDate, "day");
          var type = "normal";
          if (count < startOfMonthDay) {
            // 上个月日期
            type = "prev-month";
          } else if (count - startOfMonthDay >= dateCountOfMonth) {
            // 下个月日期
            type = "next-month";
          }
          rows_[row][col] = {
            type: type,
            date: cellDate,
            text: text,
            isSelected: isSelected || isSelectedStart || isSelectedEnd,
            isSelectedStart: isSelectedStart,
            isSelectedEnd: isSelectedEnd,
            isInRange: isInRange
          };
          count++;
        }
      }
      return rows_;
    });
    var handleDateCellClass = function handleDateCellClass(cell) {
      var classNameList = ["tui-date-table-body-days-item-cell"];
      (cell === null || cell === void 0 ? void 0 : cell.isSelected) && classNameList.push("selected");
      (cell === null || cell === void 0 ? void 0 : cell.isSelectedStart) && classNameList.push("selected-start");
      (cell === null || cell === void 0 ? void 0 : cell.isSelectedEnd) && classNameList.push("selected-end");
      (cell === null || cell === void 0 ? void 0 : cell.isInRange) && classNameList.push("range");
      return classNameList;
    };
    var handlePick = function handlePick(cell) {
      if ((cell === null || cell === void 0 ? void 0 : cell.type) !== "normal") {
        return;
      }
      emit("pick", cell);
    };
    var generateVueRenderKey = function generateVueRenderKey(rowKey, colKey) {
      return "".concat(rowKey + colKey, " ");
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("table", _hoisted_1, [_createElementVNode("tbody", _hoisted_2, [_createElementVNode("tr", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(WEEKS), function (item) {
        return _openBlock(), _createElementBlock("th", {
          "class": _normalizeClass(['tui-date-table-body-weeks-item']),
          "aria-label": item + '',
          scope: "col"
        }, _toDisplayString(_unref(TUITranslateService).t("time.".concat(item))), 9, _hoisted_4);
      }), 256))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), function (row, rowKey) {
        return _openBlock(), _createElementBlock("tr", {
          "class": _normalizeClass(['tui-date-table-body-days']),
          key: rowKey
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, function (col, colKey) {
          return _openBlock(), _createElementBlock("td", {
            key: generateVueRenderKey(rowKey, colKey),
            "class": _normalizeClass(['tui-date-table-body-days-item', col.type])
          }, [_createElementVNode("div", {
            "class": _normalizeClass([handleDateCellClass(col)]),
            onClick: function onClick($event) {
              return handlePick(col);
            }
          }, [_createElementVNode("span", _hoisted_6, _toDisplayString(col.text), 1)], 10, _hoisted_5)], 2);
        }), 128))]);
      }), 128))])]);
    };
  }
});